import React, { useState } from "react";
import { BsEmojiSmileFill } from "react-icons/bs";
import { IoMdSend } from "react-icons/io";
import styled from "styled-components";
import EmojiPicker, {EmojiStyle, EmojiClickData} 
from "emoji-picker-react";

export default function ChatInput({ handleSendMsg, selectedProduct, productDeselect, handleKeyUp, handleKeyDown}) {
  const [msg, setMsg] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const handleEmojiPickerhideShow = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleEmojiClick=( emojiData:EmojiClickData, event:MouseEvent)=>{
    setMsg((prevMessage)=>(prevMessage+=emojiData.emoji));
  };

  // In ChatInput component
const handleOptionPointer = () => {
  if (selectedProduct && typeof selectedProduct === 'string') {
    if (selectedProduct.startsWith('http')) {
      // If it's an image URL, set it directly
      setMsg(selectedProduct);
    } else {
      // For other product data
      setMsg(selectedProduct);
    }
  }
};

// Update the sendChat function
const sendChat = (event) => {
  event.preventDefault();
  if (msg.length > 0) {
    handleSendMsg(msg);
    setMsg("");
    productDeselect();
  }
};


  return (
    <Container>
      <div className="button-container">
        <div className="emoji">
          <BsEmojiSmileFill onClick={handleEmojiPickerhideShow} />
          {showEmojiPicker && <EmojiPicker onEmojiClick={handleEmojiClick}
          autoFocusSearch={false}
          emojiStyle={EmojiStyle.NATIVE} 

          />}
        </div>
      </div>
      <form className="input-container" onSubmit={(event) => sendChat(event)}>
        <textarea
          type="text"
          placeholder="Type message here"
          onChange={(e) => setMsg(e.target.value)}
          value={msg}
          onPointerDown={() => handleOptionPointer()}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
          style={{outline:'none'}}
        />
        <button type="submit">
          <IoMdSend />
        </button>
      </form>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 5% 95%;
  background-color: #080420;
  padding: 0 2rem;
  padding-left:0;
  @media screen and (min-width: 720px) and (max-width: 1080px) {
    padding: 0 1rem;
    gap: 1rem;
  }
  .button-container {
    display: flex;
    align-items: center;
    color: white;
    gap: 1rem;
    .emoji {
      position: relative;
      svg {
        font-size: 1.5rem;
        color: #ffff00c8;
        cursor: pointer;
      }
      .emoji-picker-react {
        position: absolute;
        top: -350px;
        background-color: #080420;
        box-shadow: 0 5px 10px #9a86f3;
        border-color: #9a86f3;
        .emoji-scroll-wrapper::-webkit-scrollbar {
          display: none;
        }
        .emoji-search {
          background-color: transparent;
          border-color: #9a86f3;
        }
        .emoji-group:before {
          background-color: #080420;
        }
      }
    }
  }
  .input-container {
    width: 100%;
    border-radius: 2rem;
    display: grid;
    grid-template-columns: 70% 30%;
    align-items: center;
    gap: 2rem;
    background-color: #ffffff34;
    textarea {
      width: 100%;
      min-height: 60px;
      justify-contents:center;
      height: auto;
      background-color: transparent;
      color: white;
      border: none;
      padding-left: 1rem;
      font-size: 1.2rem;
      resize: none;

      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
    }

    /* ... other styles ... */
  }
`;
